import { render, staticRenderFns } from "./InnovationLeaderboard.vue?vue&type=template&id=539d48b6"
import script from "./InnovationLeaderboard.vue?vue&type=script&lang=js"
export * from "./InnovationLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./InnovationLeaderboard.vue?vue&type=style&index=0&id=539d48b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports